<template>
  <a-modal
    class="user-add-edit-modal"
    :title="modalTitle"
    :visible="visible"
    :maskClosable="false"
    centered
    @cancel="handleCancel"
  >
    <!-- custom footer -->
    <template v-slot:footer>
      <a-button key="back" @click="handleCancel">{{$t("Common_Cancel")}}</a-button>
      <a-button
        key="submit"
        type="primary"
        :loading="loading"
        @click="handleOk"
      >
        {{ mode === "edit" ? $t("Common_Modify") : $t("Common_Enroll") }}
      </a-button>
    </template>

    <!-- contents -->
    <div class="content-group">
      <div class="require-text">{{$t("LC_ModalContext2")}}</div>
      <InputComponent
        customClass="user-input"
        type="text"
        :title="$t('TP_Edit_2_Reservation_list1')"
        moduleName="user"
        name="userName"
        :value="userName"
        :validation="['required']"
      />

      <InputComponent
        customClass="user-input"
        type="text"
        title="ID"
        moduleName="user"
        name="userId"
        :value="userId"
        :validation="['required']"
      />

      <InputComponent
        customClass="user-input"
        type="text"
        :title="$t('TP_Edit_2_Reservation_list3')"
        moduleName="user"
        name="userEmail"
        :value="userEmail"
        :validation="['required', 'email']"
      />

      <InputComponent
        customClass="user-input"
        type="password"
        :title="$t('User_Add3')"
        moduleName="user"
        name="userPasswd"
        :value="userPasswd"
        :validation="['required']"
      />

      <InputComponent
        customClass="user-input"
        type="select"
        :title="$t('User1')"
        moduleName="user"
        name="userType"
        :value="userType"
        :selectList="[
          { value: 1, text: $t('User_Add4') },
          { value: 100, text: $t('User_Add5') },
          { value: 1000, text: $t('User_Add6') },
        ]"
        :validation="['required']"
      />

      <InputComponent
        v-if="mode === 'edit'"
        customClass="user-input"
        type="select"
        :title="$t('User_Add7')"
        moduleName="user"
        name="isEnable"
        :value="isEnable"
        :selectList="[
          { value: 1, text: $t('User_Add8') },
          { value: 0, text: $t('User_Add9')},
        ]"
        :validation="['required']"
      />
    </div>
  </a-modal>
</template>

<script>
import { computed, onMounted, onUnmounted, reactive, toRefs, ref } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import { apiUrl } from "@/utils/common";
import InputComponent from "@/components/commonComponents/InputComponent";
import { useI18n } from "vue-i18n";

export default {
  name: "UserAddEditModal",
  props: {
    mode: String,
    visible: Boolean,
    userInfo: Object,
    toggleModal: Function,
  },
  components: {
    InputComponent,
  },
  setup(props) {
    const { t } = useI18n();
    const modalTitle = props.mode === "edit" ? t('User_Add10') : t('User_Add11');
    const store = useStore();
    const inputValues = computed(() => store.getters["user/GET_INPUT_VALUES"]);

    const state = reactive({
      loading: false,
      enable: true,
    });

    const {
      userNo,
      userName,
      userEmail,
      userPasswd,
      userId,
      userType,
      isEnable,
    } = props.userInfo;

    const formState = reactive({
      userName: userName ? userName : "",
      userId: userId ? userId : "",
      userEmail: userEmail ? userEmail : "",
      userPasswd: userPasswd ? userPasswd : "",
      userType: userType ? userType : null,
      isEnable: isEnable !== undefined ? isEnable : 1,
    });

    onMounted(() => {
      if (props.mode === "edit") {
        // 입력 값 스토어에 저장
        store.dispatch("user/SET_INPUT_VALUE", {
          userNo,
          userName,
          userEmail,
          userPasswd,
          userId,
          userType,
          isEnable,
        });
      }
    });

    onUnmounted(() => {
      // 입력 값 초기화
      store.dispatch("user/INIT_INPUT_VALUE");
    });

    // 필수 항목 입력 여부 체크
    const checkValid = (compareArray) => {
      let enableArray = [];
      compareArray.map((key) => {
        const value = inputValues.value[key];
        if (!!value || value === 0) {
          enableArray.push(key);
        }
      });

      state["enable"] = enableArray.length === compareArray.length;
    };

    // 취소 버튼 이벤트
    const handleCancel = () => {
      props.toggleModal();
    };

    // 등록/수정 버튼 이벤트
    const handleOk = async () => {
      state.loading = true;

      const targetArray = Object.keys(formState);
      if (props.mode === "edit") {
        checkValid(targetArray);
      } else {
        targetArray.splice(targetArray.indexOf("inEnable"), 1);
        checkValid(targetArray);
      }

      if (state["enable"]) {
        if (props.mode === "edit") {
          const updatedItems = [];
          Object.keys(inputValues.value).map((key) => {
            if (props.userInfo[key] !== inputValues.value[key]) {
              updatedItems[key] = inputValues.value[key];
            }
          });
          // 수정
          try {
            const updateParams = {
              userNo,
              ...updatedItems,
            };

            if (Object.keys(updatedItems).length > 0) {
              const response = await axios.put(apiUrl + "User", updateParams);
              if (response && !response.data.error) {
                store.dispatch("user/UPDATE_USER", response);
              }
            }
          } catch (error) {
            console.log("update user error", error);
          }
        } else {
          // 등록
          try {
            const params = {
              userName: inputValues.value.userName,
              userEmail: inputValues.value.userEmail,
              userPasswd: inputValues.value.userPasswd,
              userId: inputValues.value.userId,
              userType: inputValues.value.userType,
            };

            const response = await axios.post(apiUrl + "User", params);
            if (response && !response.data.error) {
              store.dispatch("user/ADD_USER", response);
            }
          } catch (error) {
            console.log("add user error", error);
          }
        }
        props.toggleModal();
      }
      state.loading = false;
    };

    return {
      ...toRefs(state),
      ...toRefs(formState),
      modalTitle,
      handleCancel,
      handleOk,
    };
  },
};
</script>